const foodDatabase = [
    "Pasta Bolognese", "Chicken Alfredo", "Sushi", "Caesar Salad", "Tacos",
    "BBQ Ribs", "Ratatouille", "Beef Stroganoff", "Clam Chowder", "Pad Thai",
    "Spaghetti Carbonara", "Chicken Parmesan", "Shrimp Scampi", "Margherita Pizza",
    "Lasagna", "Fish and Chips", "Fried Rice", "Eggplant Parmesan", "Gazpacho",
    "Pho", "Ramen", "Lamb Chops", "Vegetable Curry", "Chicken Tikka Masala",
    "Beef Tacos", "Minestrone Soup", "Greek Salad", "Grilled Cheese Sandwich",
    "Steak Fajitas", "Cobb Salad", "Vegetable Stir Fry", "Moussaka", "Paella",
    "Roast Chicken", "Hamburger", "Hot Dog", "Mac and Cheese", "Pulled Pork",
    "Cornbread", "Fried Chicken", "Pork Belly", "Duck Confit", "Crab Cakes",
    "Lobster Bisque", "Stuffed Peppers", "Gumbo", "Chili Con Carne", "Shepherd's Pie",
    "Shakshuka", "Chicken Quesadilla", "Beef Wellington", "Osso Buco",
    "Biryani", "Fettuccine Alfredo", "Chicken Fried Steak", "Vegetable Lasagna",
    "Stuffed Mushrooms", "Eggs Benedict", "Huevos Rancheros", "Quiche Lorraine",
    "Salmon Teriyaki", "Avocado Toast", "Korean BBQ", "Teriyaki Chicken",
    "Chicken Pho", "Spring Rolls", "Ceviche", "Shrimp Gumbo", "Beef Burgers",
    "Chocolate Soufflé", "Crème Brûlée", "Tiramisu", "Pecan Pie", "Apple Pie",
    "Banoffee Pie", "Cherry Cobbler", "Eclairs", "Cannoli", "Baklava",
    "Pavlova", "Brownies", "Cheesecake", "Churros", "Donuts", "Lemon Bars",
    "Key Lime Pie", "Ice Cream Sundae", "Mousse au Chocolat", "Sticky Toffee Pudding",
    "Panna Cotta", "Fruit Tart", "Macarons", "Croissants", "Carrot Cake"
];

export default foodDatabase;
